import React, { useCallback } from 'react';
import {
  FDBodyText,
  FDBox, FDPrimaryActionButton, FDSecondaryActionButton,
  FDStack,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import fr from 'facet-rest';
import { dataAttrs } from 'Helpers/Testing';
import {
  FACET_PLAN_SIDEBAR_QUERY_PARAM, FACET_PLAN_VIEW_SIDEBAR_BALANCE_SHEET, META_GOTO_SIDEBAR_BALANCE_SHEET,
} from 'Views/Page/Content/Templates/WhatIfTemplate/Components/Sidebar/consts';
import useQueryParams from 'Hooks/useQueryParams';
import PropTypes from 'prop-types';

const TaxStrategySettingLayout = ({ setCapitalGainsCalculatorOpenForResource }) => {
  const { resource } = useMetaLayoutContext();
  const [params, setParams] = useQueryParams();

  const openBalanceSheetSidebar = useCallback(() => {
    params.set(FACET_PLAN_SIDEBAR_QUERY_PARAM, FACET_PLAN_VIEW_SIDEBAR_BALANCE_SHEET);
    setParams(params);
  }, []);


  return (
    <FDStack direction={'row'} spacing={2}>
      <FDBox width={'400px'} flex={1} alignSelf={'center'}>
        <FDStack direction={'column'} spacing={2}>
          <FDBodyText value={resource.attr('name')} />
          {resource.withRelationship(fr.relationships.gainsBudgetCalculator.name,
            (rel) => (
              <FDBox>
                <FDPrimaryActionButton
                  {...dataAttrs('tax-strategy-value-cap-gains-calculator-btn-current-value', resource)}
                  size={'md'}
                  fullWidth={false}
                  label={rel.meta('prompt')}
                  onClick={() => {
                    setCapitalGainsCalculatorOpenForResource(resource);
                  }}
                  icon={'payments'}
                />
              </FDBox>
            ),
            () => null)}
        </FDStack>
      </FDBox>
      <FDBox width={'250px'} alignSelf={'center'}>
        <FDStack direction={'column'} spacing={1}>
          {resource.withRelationship(fr.relationships.seeValueInOtherSection.name,
            (rel) => (
              <FDSecondaryActionButton
                {...dataAttrs(`tax-strategy-value-section-${rel.meta('goto')}-btn`, resource)}
                size={'sm'}
                label={rel.meta('prompt')}
                onClick={() => {
                  switch (rel.meta('goto')) {
                    case META_GOTO_SIDEBAR_BALANCE_SHEET:
                      openBalanceSheetSidebar();
                      break;
                    default:
                      break;
                  }
                }}
              />
            ),
            () => <MetaControlField attr={'currentYearValue'} />)}
        </FDStack>
      </FDBox>
      <FDBox width={'250px'} alignSelf={'center'}>
        <FDStack direction={'column'} spacing={1}>
          {resource.withRelationship(fr.relationships.seeValueInOtherSection.name,
            (rel) => (
              <FDSecondaryActionButton
                size={'sm'}
                {...dataAttrs(`tax-strategy-value-section-${rel.meta('goto')}-btn`, resource)}
                label={rel.meta('prompt')}
                onClick={() => {
                  switch (rel.meta('goto')) {
                    case META_GOTO_SIDEBAR_BALANCE_SHEET:
                      openBalanceSheetSidebar();
                      break;
                    default:
                      break;
                  }
                }}
              />
            ),
            () => <MetaControlField attr={'nextYearValue'} />)}
        </FDStack>
      </FDBox>
      <FDBox width={'250px'} alignSelf={'center'}>
        <MetaControlField attr={'ongoingYearValue'} />
      </FDBox>
    </FDStack>
  );
};

TaxStrategySettingLayout.defaultProps = {
  setCapitalGainsCalculatorOpenForResource: null,
};

TaxStrategySettingLayout.propTypes = {
  setCapitalGainsCalculatorOpenForResource: PropTypes.func,
};

export default TaxStrategySettingLayout;
